import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { SuccessMsgUpdate } from "globalConstants";
import { getErrorMessage } from "helpers";
import { chargebacksService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseClaimChargebacksMutationProps = {
	id: string;
};

const useClaimChargebacksMutation = ({ onSuccessHandler }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseClaimChargebacksMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return chargebacksService.claimMerchant({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(data, { id }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: `Assignee ${SuccessMsgUpdate}`,
					}),
				);
				onSuccessHandler?.(id);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useClaimChargebacksMutation;
